import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../actions';
import API from '../../apis';

export const getCafesContract = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());

      return API.cafesContract
        .getCafesContract(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_CAFE_CONTRACT_FAILED,
              reject: actionTypes.GET_CAFE_CONTRACT_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_CAFE_CONTRACT_LOADING);
  const success = res => action(actionTypes.GET_CAFE_CONTRACT_SUCCESS, res);

  return request();
};

export const insertCafeContract = cafeContractObject => {
  return dispatch => {
    dispatch(action(actionTypes.INSERT_NEW_CAFE_CONTRACT_LOADING));
    return API.cafesContract
      .insertNewCafeContract(cafeContractObject)
      .then(res =>
        dispatch(action(actionTypes.INSERT_NEW_CAFE_CONTRACT_SUCCESS, res)),
      )
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.INSERT_NEW_CAFE_CONTRACT_FAILED,
            reject: actionTypes.INSERT_NEW_CAFE_CONTRACT_REJECT,
          }),
        );
        throw err;
      });
  };
};

export const clearAddOrEditCafeForm = () => {
  return action(actionTypes.CLEAR_ADD_OR_EDIT_CAFE_CONTRACT_FORM);
};

export const getCitiesContract = () => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.cafesContract
        .getCitiesContract()
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_CITIES_CONTRACT_FAILED,
              reject: actionTypes.GET_CITIES_CONTRACT_REJECT,
            }),
          );
        });
    };
  };
  const loading = () => action(actionTypes.GET_CITIES_CONTRACT_LOADING);
  const success = res => action(actionTypes.GET_CITIES_CONTRACT_SUCCESS, res);

  return request();
};

export const getCityContract = cityCode => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.cafesContract
        .getCityContract(cityCode)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_CITY_CONTRACT_FAILED,
              reject: actionTypes.GET_CITY_CONTRACT_REJECT,
            }),
          );
        });
    };
  };
  const loading = () => action(actionTypes.GET_CITY_CONTRACT_LOADING);
  const success = res => action(actionTypes.GET_CITY_CONTRACT_SUCCESS, res);

  return request();
};

export const getContractById = contractId => {
  return dispatch => {
    dispatch(action(actionTypes.GET_CONTRACT_BY_ID_LOADING));
    return API.cafesContract
      .getContractById(contractId)
      .then(res => dispatch(action(actionTypes.GET_CONTRACT_BY_ID_SUCCESS, res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_CONTRACT_BY_ID_FAILURE,
            reject: actionTypes.GET_CONTRACT_BY_ID_REJECT
          })
        );
      });
  };
};


export const updateCafeContract = cafeContractObject => {
  return dispatch => {
    dispatch(action(actionTypes.UPDATE_CAFE_CONTRACT_LOADING));
    return API.cafesContract
      .updateCafeContract(cafeContractObject)
      .then(res => dispatch(action(actionTypes.UPDATE_CAFE_CONTRACT_SUCCESS, res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.UPDATE_CAFE_CONTRACT_FAILED,
            reject: actionTypes.UPDATE_CAFE_CONTRACT_REJECT
          })
        );
        throw err;
      });
  };
};